import { addToChainAfter, addToStartOfChain, ApiHandler, ApiHandlerDiscreteParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    createHandlerChainRunnerOptionalParameter,
    Handler,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { AddCartLinesApiParameter, AddWishListToCartApiParameter, ClearCartApiParameter, RemoveCartLineApiParameter } from "@insite/client-framework/Services/CartService";
import { CallClearCart, chain, LoadCart } from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";
import { CartLineCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { addCartModifiedToLocalStorage } from "@NA/Utils/Utility";


type HandlerType = Handler<
    {
        /**
         * @deprecated this is not supported. It is here to prevent build errors because previously it could be passed in without causing a failure.
         */
        cartId?: string;
    },
    {
        apiParameter: ClearCartApiParameter;
    }
>;

export const PushAddToCartCompleteInLocalStorage: HandlerType = props => {
    addCartModifiedToLocalStorage();
};

addToStartOfChain(chain, PushAddToCartCompleteInLocalStorage); // CallClearCart,


